import { createReducer } from 'redux-create-reducer';

import {
  CONFIGURE_PENDING,
  CONFIGURE_SUCCESS,
  CONFIGURE_ERROR,
} from './constants';
import { IConfig } from './interfaces';

export const initialState: IConfig = {
  data: {
    backendUrl: {
      url: '',
    },
    backendSaseUrl: {
      url: '',
    },
    okta: {
      issuer: '',
      clientId: '',
      supportAccessGroupName: '',
    },
    phanesDomain: {
      url: '',
    },
    logForwarderAPIGWEndpoint: {
      url: '',
    },
    loggerConfig: {
      minLevel: '',
      batchInterval: 60000,
      batchLimit: 5,
      disableLogs: false,
    },
  },
  isLoading: false,
  hasLoaded: false,
  error: null,
};

export default createReducer(initialState, {
  [CONFIGURE_PENDING]: (state) => ({
    ...state,
    error: null,
    isLoading: true,
    hasLoaded: false,
  }),
  [CONFIGURE_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    error: null,
    isLoading: false,
    hasLoaded: true,
  }),
  [CONFIGURE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
    hasLoaded: true,
  }),
});
